import CoreCategoryTabs from './CoreCategoryTabs';

export { type CoreCategoryTabsProps } from './CoreCategoryTabs';
export default CoreCategoryTabs;
